import { Button, Form } from 'antd';
import { FORMDATA } from 'constants/Data';
import React, { FC, useState } from 'react';
import styles from './index.module.scss';
import { SideDrawerBodyProps } from './types';
import { postApi, putApi } from 'apis';
import { toastText } from 'utils/utils';
import "./index.scss";
import InputWithLabelAndSvg from 'components/Global/InputWithLabel';
import { useSelector } from 'react-redux';

const AddCompanyBody: FC<SideDrawerBodyProps> = (props) => {

	const { addCompanyFields } = FORMDATA;
	const { closeDrawerByAnimation, editSelectedCompany, fetchCompaines } = props;
	const profileData = useSelector((state: any) => state?.userProfile?.data);

	const [form] = Form.useForm();

	const [loading, setLoading] = useState<boolean>();


	const addComapny = async (finalData: any) => {
		try {
			setLoading(true);
			const res = await postApi('/company/create', finalData);
			toastText(res?.data?.message, 'success');
		} catch (err: any) {
			toastText(err.response.data.message || 'Something went wrong when trying to add company', 'error');
		} finally {
			setLoading(false);
		}
	};

	const updateCompany = async (finalData: any) => {
		try {
			setLoading(true);
			const res = await putApi('/company/', finalData)
			toastText(res?.data?.message, 'success');
			if (profileData.companyId === editSelectedCompany?.id) {
				window.location.reload();
			} else {
				closeDrawerByAnimation()
			}
		} catch (err: any) {
			toastText(err?.response?.data?.message, 'error');
		} finally {
			setLoading(false);
		}
	};

	const onFinish = async (values: any) => {
		// const fullName = (values.fullName as string).trim();

		if (editSelectedCompany) {
			let data: any = {
				companyId: editSelectedCompany?.id,
				...values
			};

			await updateCompany(data);
			fetchCompaines();
			closeDrawerByAnimation();

		} else {
			const finalData = {
				...values
			};
			await addComapny(finalData);
			fetchCompaines();
			window.location.reload();

		}
	};



	// JSX
	return (
		<div className={styles['side-drawer-body']}>
			<Form
				form={form}
				name="basic"
				initialValues={editSelectedCompany}
				onFinish={onFinish}
				autoComplete="off"
				layout="vertical"
				labelAlign="left"
				className={styles['side-drawer-form']}
			>
				<div className={styles['side-drawer-form__inputs']}>
					{addCompanyFields.map((singleField: any, index: number) => {
						return (
							<React.Fragment key={index}>
								{/* <div
									key={index}
									className={styles["side-drawer-form__form__inputs"]}
								>
									<label
										className={styles["side-drawer-form__inputs--label"]}
									>
										{singleField?.title}{" "}
										{singleField?.required && (
											<span className="required-color">*</span>
										)}
									</label>
									{singleField.type === "textArea" ? (
										<Form.Item
											name={singleField.name}
											className={`${styles["side-drawer-form__inputs--input"]} text-area-error`}
											rules={singleField.rules as []}
										>
											<textarea
												className={
													styles["side-drawer-form__inputs--textarea"]
												}
												placeholder={singleField.placeholder}
											/>
										</Form.Item>
									) : (
										<Form.Item
											name={singleField.name}
											className={styles["side-drawer-form__inputs--input"]}
											rules={singleField.rules as []}
										>
											<Input
												placeholder={singleField.placeholder}
												size="large"
												type={singleField.type}
											/>
										</Form.Item>
									)}
								</div> */}

								{singleField.type !== 'textArea' && (
									<InputWithLabelAndSvg
										singleUserInput={singleField}
										disabled={
											singleField?.name === 'email' &&
											editSelectedCompany &&
											true
										}
									/>
								)}
								{singleField.type === "textArea" && (
									<div
										key={index}
										className={styles["side-drawer-input"]}
									>
										<label
											className={styles["side-drawer-form--label"]}
										>
											{singleField?.title}{" "}
											{singleField?.required && (
												<span className="required-color">*</span>
											)}
										</label>
										<Form.Item
											name={singleField.name}
											className={`${styles["side-drawer-form__inputs--input"]} text-area-error`}
											rules={singleField.rules as []}
										>
											<textarea
												className={
													styles["side-drawer-form__inputs--textarea"]
												}
												placeholder={singleField.placeholder}
											/>
										</Form.Item>
									</div>)}

							</React.Fragment>
						);
					})}
				</div>
				<div className={styles['side-drawer-form__buttons']}>
					<Button
						htmlType="submit"
						className={styles['side-drawer-form__buttons--edit']}
						loading={loading} //loading
					>
						{editSelectedCompany ? 'Edit' : 'Save'}
					</Button>

					<Button
						htmlType="reset"
						className={styles['side-drawer-form__buttons--cancel']}
						disabled={loading}
						onClick={closeDrawerByAnimation}
					>
						Cancel
					</Button>
				</div>


			</Form>
		</div>
	);
};

export default AddCompanyBody;
